<script>
import { Plugins } from '@capacitor/core';
const { Device } = Plugins;
export default {
  name: 'PlatformMixin',
  async created() {
    this.pl = await this.getPlatform();
    this.ml = await this.getModel();
    this.dl = await this.getDeviceLocale();
  },
  data() {
    return {
      pl: '',
      dl: 'en',
      ml: '',
    };
  },
  computed: {
    plattform() {
      return this.pl;
    },
    isMobile() {
      return this.plattform === 'ios' || this.plattform === 'android';
    },
    model() {
      return this.ml;
    },
    deviceLocale() {
      return this.deviceLocale;
    },
  },
  methods: {
    async getPlatform() {
      return (await Device.getInfo()).platform;
    },
    async getDeviceLocale() {
      return (await Device.getLanguageCode()).value.split('-')[0].toLowerCase();
    },
    async getModel() {
      return (await Device.getInfo()).model;
    },
  },
};
</script>
